module.exports = __webpack_public_path__ + "img/logo-neos.9e38f690.svg";